import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";
import { CheckIcon } from "./icons";

export interface ActionCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  variant?: "surface" | "media" | "secondary";
}

/** A native action or selection tile. Keep sibling actions outside the card. */
export const ActionCard = forwardRef<HTMLButtonElement, ActionCardProps>(
  function ActionCard({ selected, variant = "surface", type = "button", className, children, ...props }, ref) {
    return <button ref={ref} type={type} aria-pressed={selected}
      {...props} data-selected={selected || undefined} data-variant={variant}
      className={cn("studio-action-card min-h-11 min-w-0 rounded-xl text-left text-ink outline-none transition-[background-color,border-color,transform] duration-150 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--focus-ring)] disabled:cursor-not-allowed disabled:opacity-50 motion-safe:active:scale-[0.99] disabled:motion-safe:active:scale-100", className)}>
      {children}
      {selected && variant === "media" ? <CheckIcon className="studio-action-card-selection" aria-hidden="true" /> : null}
    </button>;
  },
);
